import { render, staticRenderFns } from "./summaryTable.vue?vue&type=template&id=c86d0892&scoped=true&"
import script from "./summaryTable.vue?vue&type=script&lang=js&"
export * from "./summaryTable.vue?vue&type=script&lang=js&"
import style0 from "./summaryTable.vue?vue&type=style&index=0&id=c86d0892&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86d0892",
  null
  
)

export default component.exports